import { axiosInstance } from '../services/axiosInstance';
import catchAsync from '../utils/catchAsync';

export const addAccountingPeriod = catchAsync(async (body) => {
  const { data } = await axiosInstance.post(
    '/api/resource/Accounting Period',
    body
  );
  return data;
});

export const updateAccountingPeriod = catchAsync(async (body, id) => {
  const { data } = await axiosInstance.post(
    `/api/resource/Accounting Period/${id}`,
    body
  );
  return data;
});

export const getAccountingPeriod = catchAsync(async () => {
  const { data } = await axiosInstance.get(
    '/api/resource/Accounting Period?fields=["name","start_date","end_date"]'
  );
  return data;
});
export const getAccountingPeriodById = catchAsync(async (id) => {
  const { data } = await axiosInstance.get(
    `/api/resource/Accounting Period/${id}`
  );
  return data;
});

export const deleteAccountingPeriod = catchAsync(async (id) => {
  const { data } = await axiosInstance.delete(
    `/api/resource/Accounting Period/${id}`
  );
  return data;
});
